export const getVideoLink = (id) => {
  return "https://www.youtube.com/watch?v=" + id;
};
